import React from "react"
import PropTypes from "prop-types"
import {get} from "lodash"

import Select from "@irati/ui/src/FormItem/Select"
import Validation from "@irati/utils/validation"
import id from "@irati/utils/id"

const PROPERTY = "preferences.questionCount"

const OPTIONS = [{label: 5, value: 5}, {label: 10, value: 10}]

export const schema = Validation.number("A question count must be selected")

const QuestionCount = ({survey, onChange, label, required, ...props}) => {
  return (
    <Select
      name={PROPERTY}
      isClearable={false}
      value={get(survey, PROPERTY)}
      options={OPTIONS}
      onChange={(value) => onChange(survey, PROPERTY, value)}
      label={`${label}${required ? "*" : ""}`}
      {...props}
      id={id(PROPERTY, props)} />
  )
}

QuestionCount.propTypes = {
  required: PropTypes.bool,
  survey: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  label: PropTypes.string,
  validation: PropTypes.object
}

QuestionCount.defaultProps = {
  required: true,
  label: "Question count",
  validation: schema,
  id: "questionCount"
}

export default QuestionCount
